import React from 'react'
import { Link } from "react-router-dom";

const ToggleLinkMenu = (props) => {

  const isActive = props.isActive
  const title = props.title
  const className = props.className
  const links = props.links
  const toggleEvent = props.toggleEvent

  return (
    <div>
      <Link to="#"
        className={className}
        onClick={() => {
          if (props.mainMenuOnClick) {
            props.mainMenuOnClick()
          }
          if (!isActive) {
            toggleEvent("clickTriggerContainer")

          }
        }}
        onMouseEnter={() => {
          toggleEvent("mouseEnterTriggerContainer")
        }}
      >{title}</Link>
      <div id={"dropdown-menu-" + title} className={"dropdown-menu"}
        style={{ display: isActive ? 'flex' : 'none', flexDirection: 'row', flexWrap: 'wrap', position: 'absolute', left: 0, justifyContent: 'space-evenly', alignContent: 'flex-start', minHeight: 'unset', minWidth: 'unset', width: 'unset', maxWidth: '700px' }}
        onMouseLeave={isActive ? () => {
          toggleEvent("mouseLeaveMenuContainer")
        } : null}
      >
        {links.map((link, index) => {
          return <div key={title + index} onClick={() => { toggleEvent("clickItem") }}>{link}</div>
        })}
      </div>
    </div>
  )

}

export default ToggleLinkMenu